// share 观众标识:每个标签页一个,存 sessionStorage(标签页间隔离、刷新保留)。
// 后端以 lang|viewerId 做观众粒度订阅追踪,最后一个订阅者退订时立即释放该语言的名额。
// 注意用 sessionStorage 而非 localStorage:同一浏览器开两个标签页 = 两个观众,不能共用 id。
const STORAGE_KEY = 'share-viewer-id';

// 格式需满足后端 ShareLangForm.viewerId 的 @Pattern ^[A-Za-z0-9_-]{1,64}$(uuid 含连字符,合法)
const genId = (): string =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `v-${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;

// 隐私模式等 sessionStorage 不可用时的降级:模块级内存 id(刷新会变,后端按 TTL 兜底回收旧 id 的订阅)
const memoryFallbackId = genId();

export const getShareViewerId = (): string => {
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const id = genId();
    sessionStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return memoryFallbackId;
  }
};
